import { post } from '../utils/request';

//获取推广二维码
export const  getPopularizeQrcode = (userId, data) => {
    return post(`/ci/team_user/popularize_qrcode/${userId}`, data);
}